import { CalendarClock, ShieldAlert } from "lucide-react";
import VipMedallion from "./VipMedallion";
import { VIP_BY_TIER, VIP_TIERS, fmtCoins } from "@/lib/vipTiers";

const resetLabel = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : "the 1st of next month");

// This month's progress for the signed-in member: verified coins → next tier.
export default function VipProgress({ me }) {
  if (!me) return null;
  const cur = me.tier ? VIP_BY_TIER[me.tier] : null;
  const next = me.next ? VIP_BY_TIER[me.next.tier] : null;
  const floor = cur ? cur.coins : 0;
  const ceil = next ? next.coins : VIP_TIERS[VIP_TIERS.length - 1].coins;
  const pct = next ? Math.min(100, Math.round(((me.verified_coins - floor) / (ceil - floor)) * 100)) : 100;

  return (
    <section data-testid="vip-progress" className="card-surface p-5 sm:p-6 border border-white/8">
      <div className="flex flex-col gap-5">
        <div className="flex items-center gap-4">
          {cur ? <VipMedallion tier={cur.tier} size="lg" /> : (
            <span className="w-24 h-24 rounded-full border border-dashed border-white/15 grid place-items-center text-[10px] uppercase tracking-widest text-zinc-500 text-center px-2" data-testid="vip-progress-no-tier">No tier yet</span>
          )}
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Your status · {me.month}</div>
            <div className={`font-display text-3xl leading-tight ${cur ? cur.text : "text-white"}`} data-testid="vip-progress-tier-label">{cur ? cur.label : "Supporter"}</div>
            <div className="text-sm text-zinc-400 mt-1"><span className="text-white tabular-nums" data-testid="vip-progress-verified">{fmtCoins(me.verified_coins)}</span> verified coins purchased this month</div>
          </div>
        </div>
        <div className="flex-1">
          {me.excluded ? (
            <div data-testid="vip-progress-excluded" className="flex items-start gap-2 text-sm text-amber-200 border border-amber-500/30 bg-amber-500/[0.06] p-3"><ShieldAlert size={16} className="shrink-0 mt-0.5" /> This account is not eligible for VIP badges (test, demo or restricted account).</div>
          ) : (
            <>
              <div className="flex justify-between text-xs text-zinc-400 mb-2">
                <span>{cur ? cur.label : "Start"}</span>
                <span data-testid="vip-progress-next">{next ? `${fmtCoins(me.next.coins_remaining)} coins to ${next.label}` : "Top tier reached — Panda Boss"}</span>
              </div>
              <div className="h-2 bg-white/5 overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
                <div data-testid="vip-progress-bar" className={`h-full bg-gradient-to-r ${(next || cur || VIP_TIERS[0]).ring} transition-[width] duration-700`} style={{ width: `${pct}%` }} />
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-zinc-500 mt-3">
                <span className="flex items-center gap-1"><CalendarClock size={12} /> Resets {resetLabel(me.reset_at)}</span>
                {me.clawed_back > 0 && <span data-testid="vip-progress-clawed">−{fmtCoins(me.clawed_back)} refunded / charged back</span>}
                <span data-testid="vip-progress-gifted">Gifts sent this month: {fmtCoins(me.gifted)} coins (tracked separately — does not count)</span>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
